<template>
  <div>
    <div v-if="project">
      <app-nav-bar :project="project"></app-nav-bar>
      <app-header-slideshow :project="project"></app-header-slideshow>
      <app-count-down :event="project.event"></app-count-down>
      <app-about :project="project"></app-about>
      <app-sweetdeals></app-sweetdeals>
      <app-share :project="project"></app-share>
      <app-gallery :galleryId="1"></app-gallery>
      <app-contact></app-contact>
      <app-footer :project="project"></app-footer>
      <app-vote-now-fixed></app-vote-now-fixed>
    </div>

    <div v-else>
      <p>Something went horribly wrong</p>
    </div>
  </div>
</template>

<script>
import About from '@/components/About.vue'
import Contact from '@/components/Contact.vue'
import CountDown from '@/components/CountDown.vue'
import Footer from '@/components/Footer.vue'
import Gallery from '@/components/Gallery.vue'
import HeaderSlideshow from '@/components/HeaderSlideshow.vue'
import NavBar from '@/components/NavBar.vue'
import Share from '@/components/Share.vue'
import Sweetdeals from '@/components/Sweetdeals.vue'
import VoteNowFixed from '@/components/VoteNowFixed.vue'

export default {
  name: 'App',
  components: {
    appContact: Contact,
    appCountDown: CountDown,
    appAbout: About,
    appFooter: Footer,
    appGallery: Gallery,
    appHeaderSlideshow: HeaderSlideshow,
    appNavBar: NavBar,
    appShare: Share,
    appSweetdeals: Sweetdeals,
    appVoteNowFixed: VoteNowFixed
  },
  computed: {
    project () {
      return this.$store.getters.project
    },
    votingLink () {
      return this.$store.getters.votingLink
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/Home.vue